export default class Nsc {
  constructor(userDetails, history) {
    if (userDetails) {
      this.userId = userDetails.userId;
      this.commonName = userDetails.commonName;
      this.market = userDetails.market;
      this.fullName = userDetails.fullName;
      this.userType = userDetails.userType;
      this.privilege = userDetails.privilege;
      this.permissions = userDetails.permissions;
      if (userDetails.permissions) {
        this.originalPermissions = JSON.parse(
          JSON.stringify(userDetails.permissions)
        );
      }
      this.brand = userDetails.brand;
    }
    this.readOnly = false;
    this.history = history;
  }

  generateResourcePath() {
    return `nsc/${this.market}`;
  }
  removeReadOnlyPermissions() {
    this.permissions.rolePermissions = this.originalPermissions.rolePermissions;
  }
  addReadOnlyPermissions(permissions) {
    this.permissions.rolePermissions = Object.assign(
      {},
      permissions.rolePermissions,
      this.permissions.rolePermissions
    );
  }
}
